import UpsertTypeToNamespaceItem from '../../../../../../projects/task/i-service/models/task-type/request/UpsertTypeToNamespaceItem';

/**
 * * Модель запроса для обновления типов проекта
 */
export default class UpsertTypeToNamespaceRequest  {
	/**
	 * * Список типов
	 */
	Types!: Array<UpsertTypeToNamespaceItem>;
	/**
	 * * Номер рабочей области
	 */
	NamespaceId!: string;
	constructor(obj?: Partial<UpsertTypeToNamespaceRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
